module.exports = __webpack_public_path__ + "img/c8c3c32.jpg";